import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { FormikProps, getIn } from "formik";
import { lazy, Suspense } from "react";
import { FormField } from "../FormField";
import { FixedLabel } from "../Functions";

// Quill + react-quill ship ~78 KB gzipped. Lazy so the bundle that ferries
// non-RichText forms doesn't pay for it. Forms that don't render a
// RichTextEditor field never pull the editor at all.
const QuillEditor = lazy(() => import("../../QuillEditor/QuillEditor"));

export function RichTextEditorField({
  formik,
  field,
}: {
  formik: FormikProps<Record<string, unknown>>;
  field: FormField;
}) {
  return (
    <Grid size={{ xs: 12, sm: field.columns || 6 }} key={field.id}>
      {field.fixedLabel && <FixedLabel formik={formik} field={field} />}
      <FormControl fullWidth>
        <Suspense fallback={<Box sx={{ minHeight: 80 }} />}>
          <QuillEditor
            content={getIn(formik.values, field.id)}
            onChange={(value: string) => formik.setFieldValue(field.id, value)}
            onBlur={() => formik.handleBlur({ target: { name: field.id } })}
            maxRows={field.maxRows || undefined}
            minRows={field.minRows || undefined}
          />
        </Suspense>
        {getIn(formik.touched, field.id) &&
          Boolean(getIn(formik.errors, field.id)) && (
            <FormHelperText
              id={`${field.id}-helper-text`}
              error
              variant="standard"
            >
              {getIn(formik.errors, field.id) as string}
            </FormHelperText>
          )}
      </FormControl>
    </Grid>
  );
}

export function ActionField({ field }: { field: FormField }) {
  return (
    <Grid size={{ xs: 12, sm: field.columns || 6 }} key={field.id}>
      <IconButton aria-label={field.actionLabel} onClick={field.onClick}>
        {field.icon}
      </IconButton>
    </Grid>
  );
}

export function HeaderField({ field }: { field: FormField }) {
  return (
    <Grid size={12} sx={{ mt: 3, mb: 1 }}>
      <Typography
        variant="h6"
        color="primary"
        sx={{
          fontWeight: "medium",
        }}
      >
        {field.text}
      </Typography>
    </Grid>
  );
}

export function ReturnDisplayField({ field }: { field: FormField }) {
  return <Box component="span">{field.value as string}</Box>;
}
